import { useRef } from "react";
import classes from './TablePrint.module.scss'
import { useReactToPrint } from "react-to-print";

import QRCode from '../common/QrCodeGenerator'

const TablePrint = ({onClose, labels}) => {
    
    const componentRef = useRef();
    const printHandler = useReactToPrint({
        content: () => componentRef.current
    });

    const closeWindow = () => {
        onClose(false)
    }


  return (
    <div className={classes.container}>
        <div ref={componentRef} className={classes.container__box}>
            {labels.map((el,index)=>(
            <QRCode key={index} value={JSON.stringify(el)}/>
            ))}
        </div>
        <button className={classes.container__button}  onClick={printHandler}>Роздрукувати</button>
        <button className={classes.closeButton}  onClick={closeWindow}>X</button>
    </div>
  )
}

export default TablePrint